import React from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./Common.scss";

const Common = ({ react_header, react_footer, rbg_checkout }) => {

    return (
        <>
            {react_header &&
            <Router>
                <Switch>
                    <Route path={["/products/:handle", "/clairreport"]}>
                        <Header
                            disableSticky={true}
                            isCheckoutPage={rbg_checkout}
                        />
                    </Route>
                    <Route exact path="/collections/:col/products/:handle">
                        <Header
                            disableSticky={true}
                            isCheckoutPage={rbg_checkout}
                        />
                    </Route>
                    <Router>
                        <Header
                            disableSticky={false}
                            isCheckoutPage={rbg_checkout}
                        />
                    </Router>
                </Switch>
            </Router>
            }
            {react_footer &&
            <Footer/>
            }
        </>
    )
};

export default Common;